interface Props {
	className?: string;
}
export const XTwitterIcon: React.FC<Props> = ({ className }) => {
	return (
		<svg
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				opacity="0.2"
				d="M19.5 21.1309H15L4.5 4.63086H9L19.5 21.1309Z"
				fill="#C0D653"
			/>
			<path
				d="M20.1328 20.7287L14.264 11.5055L20.0549 5.13523C20.1859 4.9876 20.2534 4.79429 20.2428 4.59722C20.2322 4.40015 20.1444 4.2152 19.9983 4.08247C19.8523 3.94974 19.6598 3.87993 19.4626 3.88817C19.2654 3.89641 19.0794 3.98203 18.9449 4.12648L13.4287 10.194L9.63276 4.22867C9.56507 4.12213 9.47158 4.03439 9.36097 3.97359C9.25035 3.9128 9.12617 3.8809 8.99994 3.88086H4.49994C4.36547 3.88079 4.23345 3.91689 4.11771 3.98535C4.00198 4.05382 3.90677 4.15215 3.84208 4.27004C3.77738 4.38793 3.74558 4.52104 3.74998 4.65544C3.75439 4.78984 3.79485 4.92059 3.86713 5.03398L9.73588 14.2562L3.94494 20.6312C3.87732 20.7038 3.82479 20.7892 3.79039 20.8823C3.75599 20.9753 3.74041 21.0743 3.74455 21.1735C3.74869 21.2727 3.77248 21.37 3.81452 21.4599C3.85657 21.5498 3.91604 21.6305 3.98949 21.6972C4.06293 21.764 4.1489 21.8155 4.2424 21.8488C4.3359 21.8821 4.43508 21.8965 4.53419 21.8911C4.63329 21.8858 4.73035 21.8608 4.81974 21.8177C4.90914 21.7746 4.98908 21.7142 5.05494 21.6399L10.5712 15.5724L14.3671 21.5377C14.4354 21.6434 14.5291 21.7302 14.6397 21.7902C14.7503 21.8501 14.8742 21.8813 14.9999 21.8809H19.4999C19.6343 21.8808 19.7661 21.8447 19.8817 21.7763C19.9973 21.7079 20.0924 21.6096 20.1571 21.4919C20.2218 21.3742 20.2536 21.2412 20.2493 21.107C20.2451 20.9727 20.2048 20.8421 20.1328 20.7287ZM15.4115 20.3809L5.86588 5.38086H8.58463L18.134 20.3809H15.4115Z"
				fill="#7E57C2"
			/>
		</svg>

		// <svg
		// 	width="24"
		// 	height="25"
		// 	viewBox="0 0 24 25"
		// 	fill="none"
		// 	xmlns="http://www.w3.org/2000/svg"
		// 	className={className}
		// >
		// 	<path
		// 		d="M18.2437 3.13086H21.5531L14.325 11.3902L22.8281 22.6309H16.1719L10.9547 15.8152L4.99216 22.6309H1.6781L9.40779 13.7949L1.25623 3.13086H8.08123L12.7922 9.36055L18.2437 3.13086ZM17.0812 20.6527H18.914L7.08279 5.00586H5.11404L17.0812 20.6527Z"
		// 		fill="#0D0616"
		// 	/>
		// </svg>
	);
};
